import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/dashboard";

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Welcome back");
      const next = r.user?.profile?.onboarded ? from : "/onboarding";
      navigate(next, { replace: true });
    } else {
      setError(r.error);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16 md:py-24" data-testid="login-page">
      <div className="overline">Welcome back</div>
      <h1 className="font-display text-4xl text-teal-900 mt-2">Log in to Surfmatics</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-4 card-soft p-6" data-testid="login-form">
        <div>
          <label className="text-xs font-semibold text-muted-foreground" htmlFor="email">Email</label>
          <Input
            id="email"
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="h-11 mt-1"
          />
        </div>
        <div>
          <label className="text-xs font-semibold text-muted-foreground" htmlFor="password">Password</label>
          <Input
            id="password"
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="h-11 mt-1"
          />
        </div>
        {error && (
          <div className="text-sm text-terracotta-700 bg-[#FDF3F0] rounded-md px-3 py-2" data-testid="login-error">
            {error}
          </div>
        )}
        <button
          type="submit"
          data-testid="login-submit"
          disabled={busy}
          className="w-full h-11 rounded-full bg-teal-800 text-white text-sm font-medium hover:bg-teal-900 disabled:opacity-60"
        >
          {busy ? "Logging in…" : "Log in"}
        </button>
        <div className="text-xs text-muted-foreground text-center">
          Don't have an account?{" "}
          <Link to="/register" data-testid="login-register-link" className="text-teal-800 font-semibold">Create one</Link>
        </div>
      </form>
    </div>
  );
}
